//import { Alert } from 'bootstrap';
import React, { useEffect, useRef, useState } from 'react'
import { Container, Alert, Form, Button, Card } from 'react-bootstrap'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import Footer from '../../components/ui/Footer';

export default function Login () {

  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();
  const {login, currentUser, resetPassword} = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false)
  const [queryParams, setQueryParams] = useSearchParams();

  const path = queryParams.get('path');

  useEffect(() => {
    console.log(path);
    if(currentUser && path)
      navigate(path);
    else if(currentUser)
      navigate('/');
  }, [currentUser])


  async function handleGoogleSignIn(){
    try{
      setError('');
      setLoading(true);
      await login('', '', 'google');
    } catch (e) {
      setError(e.message);
    }

    setLoading(false);
  }

  return (
    <motion.div 
    initial={{ y: -150, opacity: 0}}
    animate={{ y:0, opacity: 1}}
    exit={{ opacity: 0 }}>
     <Container className='d-flex align-items-center justify-content-center' style={{ minHeight: "100vh" }}>
        <div className='w-100' style={{ maxWidth: "400px" }}>
      
      <Link className="mb-4" to="/">Back to Home</Link>

        <Card className='bg-dark border border-light'>
            <Card.Body>
                <h2 className='text-white text-center'>Log In or Sign Up</h2>
                <p className='text-white text-center'>click below</p>
                
                <div className='d-flex justify-content-center'>
                  <Button onClick={handleGoogleSignIn} className='bg-transparent mb-2'>
                    <img src={window.location.protocol + "//" + window.location.host + '/google-sign-in/google_signin_buttons/web/1x/btn_google_signin_dark_normal_web.png'}></img> 
                  </Button>
                </div>

            </Card.Body>
        </Card>

      </div>
      </Container>
      <Footer></Footer>
    </motion.div>
  )
}
